export const ChevronUpIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 13l-5.625-5.625L4.75 13"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
